
export function getDifference(array1:any, array2:any) {
  return array1.filter((object1:any) => {
    return !array2.some((object2:any) => {
      return object1.id === object2.id;
    });
  });
}